import moment from 'moment';
import find from 'lodash/find';
import pick from 'lodash/pick';
import intl from '../../../shared/intl';
import endpoints from '../../../../config/endpoints';
import http from '../../../shared/http';
import { actions as parentActions } from '../../list';
import { getFormValues } from 'redux-form';

const defaultInitialState = {
	shouldShowAdvRequestForm: false,
	openedId: null,
	isEditMode: false,
	initialFormFields: {
		requestData: {
			name: '',
			email: '',
			skype: '',
			company: '',
			product: '',
			goal_type: '',
			website: '',
			created_at: '',
			phone: ''
		},
		actionData: {
			payout: '',
			audience: ''
		}
	}
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const TOGGLE_MODAL = `${namespace}/${stateNodeName}-toggle-form`;
	const MARK_AS_READ_SUCCESS = `${namespace}/${stateNodeName}-mark-as-read-success`;
	const FETCH_DATA_ERROR = 'adv-requests-list/fetch-data-error';
	const SET_MODAL_DATA = `${namespace}/${stateNodeName}-set-modal-data`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		toggleRequestModal: () => dispatch => {
			dispatch({ type: TOGGLE_MODAL });
		},
		markAsRead: id => (dispatch, getState) => {
			const formValues = getFormValues('advForm')(getState());

			let data = {
				...formValues.requestData,
				...formValues.actionData,
				admin_viewed: true,
				id
			};

			dispatch(parentActions.toggleProgressBar());
			http({
				url: `${endpoints.ADV_REQUESTS.BASE}/${id}`,
				method: 'put',
				data,
				actions: [MARK_AS_READ_SUCCESS, FETCH_DATA_ERROR]
			})(dispatch);
			dispatch(actions.toggleRequestModal());
		},
		viewRequestDetails: id => dispatch => {
			dispatch({type: SET_MODAL_DATA, payload: id});
			dispatch(actions.toggleRequestModal());
		}
	};

	// reducers
	const reducers = {
		[TOGGLE_MODAL]: (state, action) => ({
			...state,
			[formName]: {
				...state[formName],
				shouldShowAdvRequestForm: !state[formName].shouldShowAdvRequestForm
			}
		}),
		[MARK_AS_READ_SUCCESS]: state => ({
			...state,
			data: null,
			showProgressBar: false
		}),
		[SET_MODAL_DATA]: (state, action) => ({
			...state,
			[formName]: {
				...state[formName],
				openedId : !state[formName].shouldShowAdvRequestForm ? action.payload : null
			}
		})
	};

	// selectors
	const selectors = {
		getShouldShowAdvRequestForm: state => state[namespace].advForm.shouldShowAdvRequestForm,
		getAdvFormEditMode: state => state[namespace].advForm.isEditMode,
		getAdvFormOpenedId: state => state[namespace].advForm.openedId,
		getModalData: state => {
			if (!state[namespace].advForm.shouldShowAdvRequestForm) return null;

			const translator = intl(state);
			const { data, advForm: { openedId, initialFormFields: { requestData, actionData } } } = state[`${namespace}`];
			const matchedData = find(data, { id: openedId });
			if (!matchedData) return null;
			const rawModalData = {
				...matchedData,
				created_at: getDate(matchedData.created_at, translator)
			};

			return {
				fields: {
					requestData: pick(rawModalData, Object.keys(requestData)),
					actionData: pick(rawModalData, Object.keys(actionData))
				},
				meta: {
					admin_viewed: rawModalData.admin_viewed
				}
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

const getDate = (date, intl) => {
	return `${moment(date).format('DD.MM.YYYY')} ${intl('at')} ${moment(date).format('HH:mm')}`;
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/advertisers-requests/components/adv-requests-form/index.js